import { SVGProps } from 'react';

const Code = ({
  props,
  fill = 'currentColor',
  size = 20,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 18" fill="none" {...props}>
    <path
      fill={fill}
      d="M11.022.568a.75.75 0 0 1 1.455.364l-4 16a.75.75 0 0 1-1.455-.364l4-16ZM4.22 4.22a.75.75 0 1 1 1.06 1.06L1.81 8.75l3.47 3.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4Zm10 0a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l3.47-3.47-3.47-3.47a.75.75 0 0 1 0-1.06Z"
    />
  </svg>
);

export default Code;
